import { Box, Grid, Divider } from '@mui/material';
import Stats from 'components/Stats';

export const ActiveUserCountCard = ({
  activeUserSinceDate,
  activeUserCount,
}: {
  activeUserSinceDate?: string;
  activeUserCount: number | string; // showing "loading" when fetching for number
}) => {
  return (
    <Grid key={'Active Users'}>
      <Box component={'h3'}>Active Users From {activeUserSinceDate} Until Today</Box>
      <Divider />
      {activeUserSinceDate ? (
        <Box mt={5}>
          <Grid container spacing={4}>
            <Grid key={'active_users'} style={{ width: 320 }}>
              <Stats
                title={
                  <Box>
                    <div>Active Users</div>
                  </Box>
                }
                amount={activeUserCount}
                amountTooltip={
                  <div>
                    Total of {activeUserCount} active users from {activeUserSinceDate} until today
                  </div>
                }
                chip={activeUserSinceDate}
              />
            </Grid>
          </Grid>
        </Box>
      ) : (
        <></>
      )}
    </Grid>
  );
};
